import React from "react";
import { renderToStaticMarkup } from "react-dom/server";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import logo from "../../../../src/assets/substratum-protocol/logo-substratum-protocol.webp";

import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import ModalComponent from "../modal/modal.component";
import ImageComponent from "../image/image.component";
import { useEffect } from "react";
import "./substratum-protocol-styles.scss";
import ScientistProfileBurn from "./ScientistProfileBurn";
import ScientistProfileMoshe from "./ScientistProfileMoshe";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "1",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Carter One",
  backgroundColor: "rgba(0, 0, 0, 1) ",
  color: "white",
  marginBottom: "15px",
};

const SPDrMoshe = () => {
  const [showModal, setShowModal] = React.useState("");
  const [modalData, setModalData] = React.useState({});
  const handleClick = (img, body) => {
    setModalData({
      body: body,
      image: img,
    });
    handleOpenModal();
  };
  const handleOpenModal = () => {
    setShowModal("show");
  };
  const handleCloseModal = () => {
    setShowModal("", "");
  };
  const section1Data = [
    {
      title: "",
      sectionTitleCssName: "sectionTitleSubstratumProtocol",
      text: (
        <div className="substratumProtocolBodyText">
          {/* <ImageComponent
            image={logo}
            caption="Gomsten Island"
            cssClass="imageLeft"
            handleClick={handleClick}
            modalBody={renderToStaticMarkup(<ScientistProfile />)}
          ></ImageComponent>
          <ModalComponent
            show={showModal}
            onHide={handleCloseModal}
            modalData={modalData}
          ></ModalComponent> */}

          <ScientistProfileMoshe />

          <br />
          <br />
          <a href="#pageTop">Back to Top</a>
        </div>
      ),
    },
  ];

  useEffect(() => {
    // document.body.style.backgroundImage = `url(${require("../../../../src/assets/forbidden-lands/fbl-page-background-blizzard.webp")})`;
    document.body.style.backgroundColor = "#c47768";
    document.body.style.backgroundWidth = "100vw";
    document.body.backgroundHeight = "100vh";
    document.body.style.backgroundSize = "cover";
  }, []);

  return (
    <Container>
      {/* <iframe sandbox="allow-popups allow-scripts allow-modals allow-forms allow-same-origin" 
                    style={{position: 'float', float: 'right',width: '120px', height: '240px'}} marginwidth="0" marginheight="0" scrolling="no" frameborder="0" src="//ws-na.amazon-adsystem.com/widgets/q?ServiceVersion=20070822&OneJS=1&Operation=GetAdHtml&MarketPlace=US&source=ss&ref=as_ss_li_til&ad_type=product_link&tracking_id=smokeraven-20&language=en_US&marketplace=amazon&region=US&placement=9189143701&asins=9189143701&linkId=d1384e0e6b9ef083fee35d7272a71f88&show_border=true&link_opens_in_new_window=true"></iframe> */}
      <Row>
        <Col>
          <div
            style={{
              backgroundColor: "transparent",
              fontFamily: "IM Fell Great Primer",
            }}
          >
            <div style={pageHeader}>
              <main role="main" className="inner cover text-center">
                <a name="pageTop" href="#pageTop">
                  <img
                    src={logo}
                    style={{
                      maxWidth: "400px",
                      backgroundColor: "white",
                      borderRadius: "10px",
                    }}
                    alt="Substratum Protocol campaign"
                  />
                </a>
              </main>
              <h1 className="cover-heading">THE EARTH IS BREAKING</h1>

              {/* <p className="lead leadExtra">
                <BRSubNav />
              </p> */}
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
          <Card style={cardStyle}>
            <Card.Body>
              <Card.Title
                id="cardTitle-substratum-protocol"
                className="cardTitle-substratum-protocol"
              >
                <span
                  style={{
                    color: "black",
                    textAlign: "center",
                  }}
                >
                  The Earth is breaking and two scientists are summoned to
                  descend into The Fracture to learn about The Anomaly.
                </span>
                <br />

                <small>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  Dr. Moshe Mazel
                  <span className="emoji" role="img" aria-label="lab coat">
                    🥼
                  </span>
                  <a href="./substratum-protocol-scientist-profile-burnstein-grok">
                    Dr. Burnstein Grok
                  </a>
                  <br />
                  <span className="emoji" role="img" aria-label="lab coat">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-01">
                    Session 01: The Earth is Breaking
                  </a>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-02">
                    Session 02: The Star in the Jar
                  </a>
                  <span className="emoji" role="img" aria-label="lab coat">
                    🌎
                  </span>
                  <a href="./substratum-protocol-session-03">
                    Session 03: The Gravity of Darkness
                  </a>
                </small>
              </Card.Title>
              <div>
                <ContentContainer data={section1Data} />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SPDrMoshe;
